<app-table-generator
    [tableInput]="tableInput"
    [widgetRef]="widgetRef"
    [showPagination]="false"
></app-table-generator>
